/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "accountAppBackend",
            "endpoint": "https://sduqrjd0v2.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:d5402b47-d8b1-4738-a85b-fcdcf541f02f",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_DMhRiNARm",
    "aws_user_pools_web_client_id": "2dqpbm192un53u0dvjve9bithm",
    "oauth": {
        "domain": "tempclass.auth.us-east-1.amazoncognito.com",
        "scope": ["email", "openid", "profile"],
        "redirectSignIn": "https://development.tempclass.com/,https://tempclass.com/,https://feature-status-page-deployment-tracking.d16b4j3aeln7xl.amplifyapp.com/,https://feature-stripe-ui-integration.d16b4j3aeln7xl.amplifyapp.com/,https://app.tempcomputing.com/",
        "redirectSignOut": "https://development.tempclass.com/,https://tempclass.com/,https://feature-status-page-deployment-tracking.d16b4j3aeln7xl.amplifyapp.com/,https://feature-stripe-ui-integration.d16b4j3aeln7xl.amplifyapp.com/,https://app.tempcomputing.com/",
        "responseType": "code"
    },
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 12,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
